import { render, staticRenderFns } from "./alertModal.vue?vue&type=template&id=2c488407&scoped=true"
import script from "./alertModal.vue?vue&type=script&lang=js"
export * from "./alertModal.vue?vue&type=script&lang=js"
import style0 from "./alertModal.vue?vue&type=style&index=0&id=2c488407&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c488407",
  null
  
)

export default component.exports